<script>

    import openModal from './buttons/openModal';
    import Harp from './Harp.vue';
    import HarpCreator from './HarpCreator.vue';

    export default {

        components: {
            Harp,
            HarpCreator,
            openModal
        },

        data() {
            return {
                harps: ''
            }
        },

        created() {
            this.fetch();
        },

        methods: {
            fetch() {
                axios.get('/harps')
                    .then((response) => this.harps = response.data)
            },

            onHarpHasBeenCreated(harp) {
                this.harps.push(harp);
                this.$modal.hide('add-harp');
            }
        }

    }
</script>